import {
  type CertificationRequestQueryPayload,
  certificationRequestListParams,
} from "api/clients/certificationRequests";
import { number, route, type Type } from "react-router-typesafe-routes";
import { zod } from "react-router-typesafe-routes/zod";
import * as R from "remeda";
import type { z } from "zod";

type RequestParams = NonNullable<CertificationRequestQueryPayload>;
type SearchParamsTransformed = Required<{
  [key in keyof RequestParams]: Type<RequestParams[key]>;
}>;
export const industryCertificationsRoute = route({
  searchParams: {
    ...(R.mapToObj(certificationRequestListParams, (param) => [
      param.name,
      zod<z.output<typeof param.schema>>(param.schema.unwrap()),
    ]) as SearchParamsTransformed),
    page: number().default(1),
    page_size: number().default(50),
  },
});
